import { CustomDevice, CustomDeviceReport, DeviceItem } from "@/types/device";
import { handleRequest } from ".";
import { httpAuthorized } from "@/main";

export const addCustomDeviceApi = async (
  deviceProtocol: CustomDevice
): Promise<boolean | null> => {
  return handleRequest<boolean>(
    httpAuthorized.post("/device/addCustomDevice", deviceProtocol),
    (data) => data.data.result
  );
};

// 查询船舶下设备列表（返回 id, type, name）
export const getDeviceListApi = async (
  shipId: string
): Promise<DeviceItem[] | null> => {
  return handleRequest<DeviceItem[]>(
    httpAuthorized.get("/device/getDeviceList", {
      params: { shipId },
    }),
    (data) => data.data.devices
  );
};

// [旧接口保留备用]
export const getCustomDeviceListApi = async (
  shipId: string
): Promise<CustomDevice[] | null> => {
  return handleRequest<CustomDevice[]>(
    httpAuthorized.get("/device/getCustomDeviceList", {
      params: {
        shipId: shipId,
      },
    }),
    (data) => data.data.devices
  );
};

export const getCustomDeviceInfoApi = async (
  customDeviceId: string
): Promise<CustomDevice | null> => {
  return handleRequest<CustomDevice>(
    httpAuthorized.get("/device/getCustomDeviceInfo", {
      params: {
        customDeviceId: customDeviceId,
      },
    }),
    (data) => data.data.device
  );
};

export const getCustomDeviceDataApi = async (
  customDeviceId: string
): Promise<CustomDeviceReport[] | null> => {
  return handleRequest<CustomDeviceReport[]>(
    httpAuthorized.get("/device/getCustomDeviceData", {
      params: {
        customDeviceId: customDeviceId,
      },
    }),
    (data) => data.data.data
  );
};
